import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) { }


  runOnServer<T>(callback: () => void | T) {
    if (isPlatformServer(this._platformId)) {
      callback();
    }
  }


  runOnBrowser<T>(callback: () => void | T) {
    if (isPlatformBrowser(this._platformId)) {
      callback();
    }
  }

  isBrowser() {
    return isPlatformBrowser(this._platformId);
  }

  isServer() {
    return isPlatformServer(this._platformId);
  }

  run<T>(fns: { server?: () => T, browser?: () => T }) {

    if (isPlatformServer(this._platformId) && fns.server) {
      return fns.server();
    } else if (isPlatformBrowser(this._platformId) && fns.browser) {
      return fns.browser();
    }
    return null
  }

}
